export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCAxNiAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgMjQuNjg5NkwxMy42NzA2IDE0LjIxN0MxNC4xMTM0IDEzLjgxOTYgMTQuMTEzNCAxMy4xMjU4IDEzLjY3MDYgMTIuNzI4NUwyIDIuMjU1ODYiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow-back.svg
// module id = 273
// module chunks = 0 5 6 14